/* eslint-disable react-hooks/exhaustive-deps */
// react
import { useEffect, useState, useRef } from "react"
import { useLocation, useParams, useHistory } from "react-router-dom"
import { Button, Card, Col, Container, Form, Row, Table } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"

// wijmo
import * as wjCore from "@grapecity/wijmo"
import * as wjGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"

// other

// Kairos
import { AppDispatch } from "../../../.."
import AlertComponent from "../../../../components/AlertComponent"
import ComboBox from "../../../../components/ComboBox"
import MonthInput from "../../../../components/InputWrapper/MonthInput"
import util from "../../../../ts/util"
import Ajv, { ErrorObject } from "ajv"
import ajvErrors from "ajv-errors"
import { TInvoiceHeaderMakePutReqSchema } from "../../../../service/billing/invoice/invoiceHeaderSchema"
import { T区分マスタ } from "../../../../components/ComboBox/KubunComboBox"
import { T表紙分割 } from "../../../../components/ComboBox/HyosiBunkatuComboBox"
import TextInput from "../../../../components/InputWrapper/TextInput"
import TextAreaInput from "../../../../components/InputWrapper/TextAreaInput"
import FlexGridOuter from "../../../../components/FlexGridWrapper/FlexGridOuter"
import Spinner from "../../../../components/Spinner"
import { showInfoToast } from "../../../../components/CustomToast"
import ConfirmModal from "../../../../components/Modal/ConfirmModal"
import CONST from "../../../../constant"
import {
  clearAlert,
  setInfoAlerts,
  setWarningAlerts,
} from "../../../../globalStore/alertStore"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../../globalStore/progressStore"

import { RootState } from "../../../../globalStore/rootreducer"
import { setAlerts } from "../../../../globalStore/alertStore"
import { TApiResponse } from "../../../../service/TApiResponse"
import NinusiService from "../../../../service/master/ninusi/ninusiService"
import MakeInvoiceService from "../../../../service/billing/invoice/makeInvoiceService"
import {
  TInvoiceHeaderListGetReq,
  TInvoiceHeaderListGetRes,
  TInvoiceHeaderListPutReq,
  TInvoiceHeaderUtiwake,
  TInvoiceHeaderMakePutReqValidate,
  TInvoicePrintSeikyusyoReq,
} from "../../../../service/billing/invoice/TInvoice"
import SyohizeiKanriService from "../../../../service/master/syohizeiKanri/syohizeiKanriService"
import { TSyohizeiKanriListGetReq } from "../../../../service/master/syohizeiKanri/TSyohizeiKanri"
import InvoiceHeaderService from "../../../../service/billing/invoice/invoiceHeaderService"
import NinusiSeikyuService from "../../../../service/master/ninusiseikyu/ninusiSeikyuService"
import {
  TNinusiSeikyuListGetRes,
  TSeikyuUtiwakeListInfo,
} from "../../../../service/master/ninusiseikyu/TNinusiSeikyu"
import { 区分分類コード } from "../../../../constant/enum/codes"

import {
  TWijmoCellTemplateContext,
  TWijmoComboBox,
} from "../../../../type/wijmoComponents"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faFileAlt } from "@fortawesome/free-solid-svg-icons"
import KubunService from "../../../../service/master/kubun/kubunService"
import {
  e消費税計算区分,
  e請求書作成区分,
} from "../../../../constant/enum/master"
import Decimal from "decimal.js"
import MakeInvoicePrintModal from "../MakeInvoice/MakeInvoicePrintModal"
import { e請求支払処理状態区分 } from "../../../../constant/enum/zyutuHaisya"
import dayjs from "dayjs"
import { useGridEventHandler } from "../../../../ts/hooks/useGridEventHandler"
//import { isNull } from "lodash"

// 合計グリッドデータ用
type TSummaryGrid = {
  運送料課税額: number | null | undefined
  運送料非課税額: number | null | undefined
  付帯料課税額: number | null | undefined
  付帯料非課税額: number | null | undefined
  高速料: number | null | undefined
  //高速料消費税: number | null | undefined
  請求合計消費税: number | null | undefined
  請求合計額: number | null | undefined
}

const create荷主請求DataMap = (
  item: TSeikyuUtiwakeListInfo[]
): wjGrid.DataMap => {
  const InnerMap = item.map((d) => ({
    ...d,
    displayMemberPath: `${d.請求内訳コード}: ${d.請求内訳名} (${d.荷主請求内訳ID})`,
  }))

  return new wjGrid.DataMap(InnerMap, "荷主請求内訳ID", "displayMemberPath")
}

/**
 * 請求処理
 * @returns
 */
const InvoiceHeader = () => {
  const history = useHistory()
  const location = useLocation()
  const { id: paramId, cp: paramCp } = useParams<{ id: string; cp: string }>()
  const id = paramId ? parseInt(paramId) : 0
  const cp = paramCp ? parseInt(paramCp) : 0
  const disPatch: AppDispatch = useDispatch()
  const { zengetuStr: 前月 } = useSelector((state: RootState) => state.date)

  // 戻る確認ダイアログ表示フラグ
  const isPrompt = useRef(false)

  // ページエンター時のクエリを保持。AsyncAutoCompleteのdefaultValue用
  //   const firstQuery = queryString.parse(location.search)

  //TODO:ページ名称確定必須
  let gridId = "InvoiceHeader_GridId"

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (
    data: Array<TInvoiceHeaderListGetRes>,
    pageSize: number
  ) =>
    new wjCore.CollectionView(data, {
      pageSize,
      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
      onCurrentChanged() {
        setIs合計再計算フラグ(true)
      },
    })

  /**
   * 合計collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createSummaryCollectionView = (data: Array<any>, pageSize: number) =>
    new wjCore.CollectionView(data, {
      pageSize,
    })

  /**
   * データ取得
   */
  const getData = async (reSearchFlg: boolean = false) => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に

    let currentSearchCondition: TInvoiceHeaderListGetReq | undefined
    // 検索条件生成
    currentSearchCondition = createSearchCondition()

    try {
      const res = await new InvoiceHeaderService().get(currentSearchCondition)
      if (res.data) {
        // 検索結果をstateにセット
        // TODO:詰め方をチェック
        const ninusiCode = res.data[0].荷主コード ? res.data[0].荷主コード : ""

        set荷主コード(ninusiCode)
        set荷主名(res.data[0].荷主名 ? res.data[0].荷主名 : "")

        if (!reSearchFlg) {
          // 初期表示時
          inputNinusiCode(ninusiCode)
          set荷主請求id初期値(res.data[0].荷主請求ID ?? 0)

          // 荷主請求内訳DataMapを設定
          if (res.data[0].荷主請求ID != null && res.data[0].荷主請求ID !== 0) {
            await get荷主請求内訳DataMap(res.data[0].荷主請求ID)
          }
        }
        set請求年月(res.data[0].請求年月 ? res.data[0].請求年月 : "")

        if (cp) {
          set請求番号("")
        } else {
          set請求番号(res.data[0].請求伝票番号 ? res.data[0].請求伝票番号 : "")
        }
        set請求処理状態区分コード(
          res.data[0].請求処理状態区分コード
            ? res.data[0].請求処理状態区分コード
            : ""
        )
        set対象期間(
          (util.date.format(res.data[0].対象期間開始日, "YYYY/MM/DD")
            ? util.date.format(res.data[0].対象期間開始日, "YYYY/MM/DD")
            : "") +
            "～" +
            (util.date.format(res.data[0].対象期間終了日, "YYYY/MM/DD")
              ? util.date.format(res.data[0].対象期間終了日, "YYYY/MM/DD")
              : "")
        )
        setフッター備考(
          res.data[0].フッター備考 ? res.data[0].フッター備考 : ""
        )
        set請求合計更新日時(
          res.data[0].請求合計更新日時 ? res.data[0].請求合計更新日時 : ""
        )

        //インボイス対応により削除
        // if (res.data[0].税込区分名称) {
        //   set高速料項目表題("高速料（" + res.data[0].税込区分名称 + "）")
        // }

        let inner表紙編集モード = false
        if (res.data[0].請求書作成区分コード !== e請求書作成区分.手作成) {
          // 手作成以外は請求明細は削除できない
          if (flexGrid) {
            flexGrid.allowDelete = false
          }
          set表紙編集モード("1")
          inner表紙編集モード = true
        } else {
          if (flexGrid) {
            flexGrid.allowDelete = true
          }
        }

        res.data.forEach((row) => {
          row.修正前請求内訳消費税 = row.請求内訳消費税
          row.修正前合計額 = row.合計額
          row.修正前請求内訳名 = row.請求内訳名

          if (inner表紙編集モード) {
            switch (row.金額区分コード) {
              case "1":
              case "2":
                // 運送料・付帯料
                if (row.請求内訳名 && row.金額区分名称) {
                  row.請求内訳名 = row.請求内訳名 + "：" + row.金額区分名称
                }
                break

              case "3":
                // 高速料
                if (row.請求内訳名 && row.金額区分名称) {
                  row.請求内訳名 = row.請求内訳名 + "：" + row.金額区分名称
                }
                row.課税区分名称 = row.税込区分名称
                break

              default:
                // その他請求額
                if (row.車番) {
                  row.請求内訳名 = row.請求内訳名 + "（" + row.車番 + "）"
                }
                break
            }
          }
        })
        setGridData({ data: createCollectionView(res.data, pageSize) })

        // 合計グリッドデータ作成
        const summaryData: TSummaryGrid[] = [
          {
            運送料課税額: res.data[0].運送料課税額,
            運送料非課税額: res.data[0].運送料非課税額,
            付帯料課税額: res.data[0].付帯料課税額,
            付帯料非課税額: res.data[0].付帯料非課税額,
            高速料: res.data[0].高速料,
            // 高速料消費税: calcSyohizeiKosoku(
            //   res.data[0].高速料 ? Number(res.data[0].高速料) : 0
            // ),
            請求合計消費税: res.data[0].請求合計消費税,
            請求合計額: res.data[0].請求合計額,
          },
        ]
        setSummaryGridData({
          data: createSummaryCollectionView(summaryData, 1),
        })
      }
    } catch (error) {
      // dispatch(setAlerts(error))
      dispatch(setWarningAlerts(["エラー表示"]))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
    }
  }

  // /**
  //  * 高速料とその消費税ををフォーマット後に連結させる
  //  * @param Kosokuryo
  //  * @param syohizeiKosoku
  //  */
  // const convertNumberToString = (Kosokuryo: any, syohizeiKosoku: any) => {
  //   if (Kosokuryo === null || Kosokuryo === undefined) {
  //     return "0" // 高速料がnull や undefined の場合は0を返す
  //   }
  //   let KosokuryoHyoji =
  //     formatNumber(Kosokuryo).toString() +
  //     " (" +
  //     formatNumber(syohizeiKosoku).toString() +
  //     ")"
  //   return KosokuryoHyoji // それ以外の場合は高速料に消費税を連結して文字列に変換して返す
  // }

  /**
   * 検索条件作成
   * @param queryString
   */
  const createSearchCondition = (
    queryString?: string
  ): TInvoiceHeaderListGetReq => {
    return {
      請求合計ID: id,
    }
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjGrid.FlexGrid) => {
    grid.formatItem.addHandler(formatItem)
    grid.beginningEdit.addHandler(beginningEdit)
    grid.cellEditEnding.addHandler(cellEditEnding)
    grid.cellEditEnded.addHandler(cellEditEnded)

    grid.refresh()
  }
  const summaryGridInitializedHandler = async (grid: wjGrid.FlexGrid) => {
    // ヘッダー結合
    mergeHeader(grid)
  }
  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjGrid.FlexGrid, e: wjGrid.FormatItemEventArgs) => {
    if (e.panel === f.cells) {
      const cellBinding = e.getColumn().binding
      let col = f.columns[e.col]
      if (cellBinding !== null && e.getRow().dataIndex !== -1) {
        switch (col.binding as keyof TInvoiceHeaderListGetRes) {
          //インボイス対応により削除
          // case "請求内訳消費税":
          //   if (e.getRow().dataItem.金額区分コード !== "3") {
          //     if (e.getRow().dataItem.課税区分コード !== "2") return
          //   }
          //   // 非課税、もしくは、高速料の場合はreadonly
          //   wjCore.toggleClass(e.cell, "read-only-cell", true)
          //   break

          case "課税区分コード":
            if (e.getRow().dataItem.金額区分コード !== "3") return
            // 高速料の場合はreadonly
            wjCore.toggleClass(e.cell, "read-only-cell", true)
            //高速料は課税区分を課税固定にする
            e.getRow().dataItem.課税区分コード = 1
            break

          //インボイス対応により削除
          // case "税込区分コード":
          //   if (e.getRow().dataItem.金額区分コード === "3") return
          //   // 高速料以外の場合はreadonly
          //   wjCore.toggleClass(e.cell, "read-only-cell", true)
          //   break

          default:
            break
        }
      }
    }
  }
  /**
   * セル編集開始時イベント
   * @param s
   * @param e
   * @returns
   */
  const beginningEdit = (s: wjGrid.FlexGrid, e: wjGrid.CellRangeEventArgs) => {
    if (e.panel === s.cells) {
      const cellBinding = e.getColumn().binding
      let col = s.columns[e.col]
      if (cellBinding !== null && e.getRow().dataIndex !== -1) {
        switch (col.binding as keyof TInvoiceHeaderListGetRes) {
          //インボイス対応により削除
          // case "請求内訳消費税":
          //   if (e.getRow().dataItem.金額区分コード !== "3") {
          //     if (e.getRow().dataItem.課税区分コード !== "2") return
          //   }
          //   // 非課税、もしくは、高速料の場合は入力不可
          //   e.cancel = true
          //   break

          case "課税区分コード":
            if (e.getRow().dataItem.金額区分コード !== "3") return
            // 高速料の場合は入力不可
            e.cancel = true
            break

          //インボイス対応により削除
          // case "税込区分コード":
          //   if (e.getRow().dataItem.金額区分コード === "3") return
          //   // 高速料以外の場合は入力不可
          //   e.cancel = true
          //   break

          default:
            break
        }
      }
    }
  }

  /**
   * セル編集完了時イベント
   */
  const cellEditEnded = (s: wjGrid.FlexGrid, e: wjGrid.CellRangeEventArgs) => {
    if (表紙編集モード === "1") {
      // 請求書表紙編集時
      cellEditEndedForHyosiHensyu(s, e)
    } else {
      // 請求書表紙手作成時
      cellEditEndedForTesakusei(s, e)
    }
  }

  const cellEditEndedForHyosiHensyu = (
    s: wjGrid.FlexGrid,
    e: wjGrid.CellRangeEventArgs
  ) => {
    // 当該明細行の合計額に消費税額の変更を反映
    const 修正前合計額 = e.getRow().dataItem.修正前合計額
      ? Number(e.getRow().dataItem.修正前合計額)
      : 0
    const 請求内訳消費税 = e.getRow().dataItem.請求内訳消費税
      ? Number(e.getRow().dataItem.請求内訳消費税)
      : 0
    const 修正前請求内訳消費税 = e.getRow().dataItem.修正前請求内訳消費税
      ? Number(e.getRow().dataItem.修正前請求内訳消費税)
      : 0
    e.getRow().dataItem.合計額 =
      修正前合計額 + 請求内訳消費税 - 修正前請求内訳消費税

    flexGrid?.refresh()

    // 請求合計に消費税額の変更を反映
    if (summaryFlexGrid == null) return

    let 請求合計消費税 = 0
    let 請求合計額 = 0

    s.collectionView.sourceCollection.forEach((row: TInvoiceHeaderUtiwake) => {
      請求合計消費税 += row.請求内訳消費税 ? Number(row.請求内訳消費税) : 0
      請求合計額 += row.合計額 ? Number(row.合計額) : 0
    })

    const summaryData: TSummaryGrid =
      summaryFlexGrid.collectionView.sourceCollection[0]

    summaryData.請求合計消費税 = 請求合計消費税
    summaryData.請求合計額 = 請求合計額

    summaryFlexGrid.refresh()
  }

  const cellEditEndedForTesakusei = (
    s: wjGrid.FlexGrid,
    e: wjGrid.CellRangeEventArgs
  ) => {
    // 当該明細行の合計額などを再計算
    const rowData: TInvoiceHeaderListGetRes = e.getRow().dataItem
    let 入力セル名: keyof TInvoiceHeaderListGetRes | "" = ""

    if (e.panel === s.cells) {
      const cellBinding = e.getColumn().binding
      let col = s.columns[e.col]
      if (cellBinding !== null && e.getRow().dataIndex !== -1) {
        入力セル名 = col.binding as keyof TInvoiceHeaderListGetRes
      }
      switch (入力セル名) {
        case "荷主請求内訳ID":
          const 荷主請求内訳: TSeikyuUtiwakeListInfo | undefined =
            荷主請求内訳DataMap?.getDataItem(rowData.荷主請求内訳ID)
          rowData.請求内訳名 = 荷主請求内訳?.請求内訳名
          rowData.請求内訳コード = 荷主請求内訳?.請求内訳コード
          s.refresh()
          break
        default:
          break
      }
    }

    let 内訳金額 = rowData.金額 ? Number(rowData.金額) : 0
    let 内訳消費税 = 0

    if (rowData.金額区分コード !== "3") {
      // 高速料以外
      if (rowData.課税区分コード === "1") {
        // 課税
        if (入力セル名 === "請求内訳消費税") {
          内訳消費税 = rowData.請求内訳消費税
            ? Number(rowData.請求内訳消費税)
            : 0
        } else {
          内訳消費税 = calcSyohizei(内訳金額)
        }
      }
    }

    rowData.請求内訳消費税 = 内訳消費税
    rowData.合計額 = 内訳金額 + 内訳消費税

    flexGrid?.refresh()
  }

  const 合計額再計算 = (grid?: wjGrid.FlexGrid) => {
    let s = grid
    if (summaryFlexGrid == null) return
    if (s == null) {
      if (flexGrid == null) return
      s = flexGrid
    }

    let 運送料課税額 = 0
    let 運送料非課税額 = 0
    let 付帯料課税額 = 0
    let 付帯料非課税額 = 0
    let 高速料 = 0
    let 請求合計消費税 = 0
    let 請求合計額 = 0

    s.collectionView.sourceCollection.forEach((row: TInvoiceHeaderUtiwake) => {
      //集計用消費税額 = row.請求内訳消費税 ? Number(row.請求内訳消費税) : 0

      //合計値の消費税をリセット
      請求合計消費税 = 0
      請求合計額 = 0

      switch (row.金額区分コード) {
        case "1":
          // 運送料
          if (row.課税区分コード === "1") {
            // 課税
            運送料課税額 += row.金額 ? Number(row.金額) : 0
          } else {
            // 非課税
            運送料非課税額 += row.金額 ? Number(row.金額) : 0
          }
          break

        case "2":
          // 付帯料
          if (row.課税区分コード === "1") {
            // 課税
            付帯料課税額 += row.金額 ? Number(row.金額) : 0
          } else {
            // 非課税
            付帯料非課税額 += row.金額 ? Number(row.金額) : 0
          }
          break

        case "3":
          // 高速料
          高速料 += row.金額 ? Number(row.金額) : 0
          // if (row.税込区分コード !== "0") {
          //   // 税抜
          //   集計用消費税額 = 0
          // }
          break

        case "4":
          // その他請求
          if (row.課税区分コード === "1") {
            // 課税
            運送料課税額 += row.金額 ? Number(row.金額) : 0
          } else {
            // 非課税
            運送料非課税額 += row.金額 ? Number(row.金額) : 0
          }
          break

        default:
          break
      }

      //インボイス対応
      //請求合計消費税 += 集計用消費税額
      //請求合計額 += row.合計額 ? Number(row.合計額) : 0

      //消費税は課税分の合計値から計算する(高速料も課税分に含む)
      請求合計消費税 += calcSyohizei(
        運送料課税額 + 付帯料課税額 + 高速料
          ? Number(運送料課税額 + 付帯料課税額 + 高速料)
          : 0
      )
      請求合計額 +=
        運送料課税額 +
        運送料非課税額 +
        付帯料課税額 +
        付帯料非課税額 +
        高速料 +
        請求合計消費税
    })

    const summaryData: TSummaryGrid =
      summaryFlexGrid.collectionView.sourceCollection[0]

    summaryData.運送料課税額 = 運送料課税額
    summaryData.運送料非課税額 = 運送料非課税額
    summaryData.付帯料課税額 = 付帯料課税額
    summaryData.付帯料非課税額 = 付帯料非課税額
    summaryData.高速料 = 高速料
    summaryData.請求合計消費税 = 請求合計消費税
    summaryData.請求合計額 = 請求合計額

    summaryFlexGrid.refresh()
  }

  // 消費税額の算出
  const calcSyohizei = (金額: number) => {
    const 消費税計算区分 = 消費税計算区分コード ? 消費税計算区分コード : ""
    let 消費税額 = new Decimal(金額).times(消費税率).div(100)

    switch (消費税計算区分) {
      case e消費税計算区分.四捨五入:
        // 四捨五入
        return 消費税額.round().toNumber()

      case e消費税計算区分.切り捨て:
        // 切り捨て
        return 消費税額.trunc().toNumber()

      case e消費税計算区分.切り上げ:
        // 切り上げ
        return 消費税額.ceil().toNumber()
      default:
        return 消費税額.round().toNumber()
    }
  }

  // 消費税率の取得
  const getSyohizeiRitu = async (適用日?: string | null) => {
    const param: TSyohizeiKanriListGetReq = {
      適用日: 適用日,
      削除済み包含フラグ: false,
    }

    try {
      const res = await new SyohizeiKanriService().getList(param)

      if (res.data == null || res.data.length <= 0) {
        set消費税率(0)
      } else {
        set消費税率(res.data[0].消費税率 ?? 0)
      }
    } catch (error) {
      dispatch(setAlerts(error))
    }
  }

  const cellEditEnding = (
    s: wjGrid.FlexGrid,
    e: wjGrid.CellEditEndingEventArgs
  ) => {
    // キャンセルの場合処理しない

    if (e.cancel) return
  }

  /**
   * ヘッダー結合処理
   */
  const mergeHeader = (grid: wjGrid.FlexGrid) => {
    // header行に一行追加
    let extraRow = new wjGrid.Row()
    extraRow.allowMerging = true
    let columnHeaders = grid.columnHeaders
    columnHeaders.rows.splice(0, 0, extraRow)

    columnHeaders.columns.forEach((c, index) => {
      if (c.binding != null) {
        let setHeaderText = ""
        if (["運送料課税額", "運送料非課税額"].includes(c.binding)) {
          setHeaderText = "運送料・その他"
        } else if (["付帯料課税額", "付帯料非課税額"].includes(c.binding)) {
          setHeaderText = "運送付帯料"
        } else if (["高速料"].includes(c.binding)) {
          setHeaderText = "高速料"
        } else {
          setHeaderText = c.header ?? ""
        }
        c.allowMerging = true
        columnHeaders.setCellData(0, index, setHeaderText)
      }
    })
    // ヘッダのみAlignを調整する
    grid.itemFormatter = (panel, r, c, cell) => {
      let setHeaderTextAlign = ""
      if (panel.cellType === wjGrid.CellType.ColumnHeader) {
        if (r === 0) {
          switch (panel.columns[c].binding) {
            case "運送料課税額":
              setHeaderTextAlign = "center"
              break
            case "運送料非課税額":
              setHeaderTextAlign = "center"
              break
            case "付帯料課税額":
              setHeaderTextAlign = "center"
              break
            case "付帯料非課税額":
              setHeaderTextAlign = "center"
              break
            case "高速料":
              setHeaderTextAlign = "center"
              break
          }
        }
        cell.style.textAlign = setHeaderTextAlign
      }
    }
  }

  /**
   * 送信前バリデーションチェックなど
   */
  const beforeSubmit = (openModal: "印刷" | "登録更新") => {
    //TODO: ここにバリデーションチェックを実装
    clearError()

    const ajv = new Ajv({ allErrors: true })
    ajvErrors(ajv)
    let schema

    if (!id) {
      // 請求書表紙手作成時
      schema = TInvoiceHeaderMakePutReqSchema
      const data: TInvoiceHeaderMakePutReqValidate = {
        荷主コード: 荷主コード ?? null,
        荷主請求ID: 荷主請求id ?? null,
        フッター備考: フッター備考 ?? "",
        請求処理状態区分コード: 請求処理状態区分コード ?? null,
      }
      const validate = ajv.compile(schema)
      const validateResult = validate(data)
      if (!validateResult) {
        const errors = validate.errors

        if (errors != null && errors.length > 0) {
          //エラーメッセージのparamsより対象の項目を発見し色変え
          setValidateError(errors)
          disPatch(
            setWarningAlerts([
              ...errors
                .filter((e) => e.message != null)
                .map((e) => e.message ?? ""),
            ])
          )
        }
        return
      }
      if (請求書作成区分コード !== e請求書作成区分.手作成) {
        //「請求書作成区分：手作成」以外の場合
        dispatch(
          setWarningAlerts([
            "「請求書作成区分：手作成」の表紙名を選択してください",
          ])
        )
        return
      }
    }

    // 手作成で請求内訳が1件もない場合もエラー
    if (請求書作成区分コード === e請求書作成区分.手作成 && flexGrid) {
      const 請求内訳List: TInvoiceHeaderListGetRes[] =
        flexGrid.collectionView.sourceCollection
      if (請求内訳List.length <= 0) {
        dispatch(
          setWarningAlerts(["請求内訳行が存在しないため、登録できません。"])
        )
        return
      }
      // 金額区分のいないレコードがいる場合もエラー
      if (
        請求内訳List.some(
          (s) => s.金額区分コード == null || s.金額区分コード === ""
        )
      ) {
        dispatch(
          setWarningAlerts(["金額区分が選択されていない請求内訳が存在します。"])
        )
        return
      }
    }
    if (openModal === "印刷") {
      setIsShowPrint(true)
    } else {
      setIsConfirmModalShow(true)
    }
  }

  /**
   * エラー発生時の項目色変え
   * @param errors
   */
  const setValidateError = (
    errors: ErrorObject<string, Record<string, any>, unknown>[]
  ) => {
    const instancePaths = errors.map((e) => e.instancePath.replaceAll("/", ""))
    const requiredProperties = errors
      .filter(
        (e) =>
          e.instancePath === "" &&
          e.params.errors != null &&
          e.params.errors.length > 0 &&
          e.params.errors.find(
            (ec: { keyword: string }) => ec.keyword === "required"
          )
      )
      .map((e) => {
        const error = e.params.errors[0]
        return error.params.missingProperty
      })
    const errorProperties = [...instancePaths, ...requiredProperties]

    setIsInvalid荷主コード(errorProperties.includes("荷主コード"))
    setIsInvalid荷主請求ID(errorProperties.includes("荷主請求ID"))
    setIsInvalidフッター備考(errorProperties.includes("フッター備考"))
    setIsInvalid請求処理状態区分コード(
      errorProperties.includes("請求処理状態区分コード")
    )
  }

  const clearError = () => {
    dispatch(clearAlert())

    setIsInvalid荷主コード(false)
    setIsInvalid荷主請求ID(false)
    setIsInvalidフッター備考(false)
    setIsInvalid請求処理状態区分コード(false)
  }

  /**
   * 送信
   */
  const submit = async () => {
    if (cp) {
      // 請求書表紙複写作成時
      await submitForTesakusei()
    } else {
      if (id) {
        // 請求書表紙編集時
        await submitForHyosiHensyu()
      } else {
        // 請求書表紙手作成時
        await submitForTesakusei()
      }
    }
  }

  const submitForHyosiHensyu = async () => {
    try {
      // バリデーション完了後のため数値は正常だが エラー回避のためここでも確認

      const detailItems = gridData.data.sourceCollection
      const seikyuUtiwakeList: TInvoiceHeaderUtiwake[] = []
      let 更新対象請求内訳名 = ""

      detailItems.forEach((row: TInvoiceHeaderListGetRes) => {
        if (表紙編集モード === "1") {
          更新対象請求内訳名 = row.修正前請求内訳名 ?? ""
        } else {
          更新対象請求内訳名 = row.請求内訳名 ?? ""
        }
        let utiwakeRow: TInvoiceHeaderUtiwake = {
          請求内訳ID: row.請求内訳ID,
          荷主請求内訳ID: row.荷主請求内訳ID ?? undefined,
          金額区分コード: row.金額区分コード,
          課税区分コード: row.課税区分コード,
          税込区分コード: row.税込区分コード
            ? row.税込区分コード
            : 高速料税込区分コード,
          請求内訳名: 更新対象請求内訳名,
          数量: row.数量 ?? 0,
          金額: row.金額 ?? 0,
          請求内訳消費税: row.請求内訳消費税 ?? 0,
          合計額: row.合計額 ?? 0,
          備考: row.備考,
          請求内訳更新日時: row.請求内訳更新日時,
        }
        seikyuUtiwakeList.push(utiwakeRow)
      })

      const summaryItems = summaryGridData.data.sourceCollection[0]

      const data: TInvoiceHeaderListPutReq = {
        請求合計ID: id,
        荷主コード: 荷主コード,
        荷主請求ID: 荷主請求id,
        請求年月: util.date.format(請求年月, "YYYY/MM/DD"),
        対象期間開始日: util.date.format(対象期間開始日, "YYYY/MM/DD"),
        対象期間終了日: util.date.format(対象期間終了日, "YYYY/MM/DD"),
        運送料課税額: summaryItems.運送料課税額,
        運送料非課税額: summaryItems.運送料非課税額,
        付帯料課税額: summaryItems.付帯料課税額,
        付帯料非課税額: summaryItems.付帯料非課税額,
        高速料: summaryItems.高速料,
        消費税: summaryItems.請求合計消費税,
        請求合計額: summaryItems.請求合計額,
        ヘッダー備考: "",
        フッター備考: フッター備考,
        請求処理状態区分コード: 請求処理状態区分コード,
        請求内訳情報リスト: seikyuUtiwakeList,
        請求合計更新日時: 請求合計更新日時,
      }

      const service = new InvoiceHeaderService()

      let res: TApiResponse<boolean>
      res = await service.put(id, data)
      disPatch(setAlerts(res))
      if (res) {
        // 更新結果を再検索
        getData(true).finally(() => {
          disPatch(画面ロック解除())
          isPrompt.current = false
          showInfoToast(`請求書表紙の更新が完了しました`)
        })
      }
    } catch (error) {
      disPatch(setAlerts(error))
    } finally {
      setIsConfirmModalShow(false)
    }
  }

  const submitForTesakusei = async () => {
    try {
      // バリデーション完了後のため数値は正常だが エラー回避のためここでも確認

      const detailItems = gridData.data.sourceCollection
      const seikyuUtiwakeList: TInvoiceHeaderUtiwake[] = []

      detailItems.forEach((row: TInvoiceHeaderUtiwake) => {
        let utiwakeRow: TInvoiceHeaderUtiwake = {
          請求内訳ID: 0,
          荷主請求内訳ID: row.荷主請求内訳ID,
          金額区分コード: row.金額区分コード,
          課税区分コード: row.課税区分コード,
          税込区分コード: 高速料税込区分コード,
          請求内訳名: row.請求内訳名,
          数量: row.数量,
          金額: row.金額,
          請求内訳消費税: row.請求内訳消費税,
          合計額: row.合計額,
          備考: row.備考,
        }
        seikyuUtiwakeList.push(utiwakeRow)
      })

      const summaryItems = summaryGridData.data.sourceCollection[0]

      let seikyuYM = (請求年月 ? dayjs(請求年月) : dayjs())
        .startOf("month")
        .toDate()

      const data: TInvoiceHeaderListPutReq = {
        請求合計ID: 0,
        荷主コード: 荷主コード,
        荷主請求ID: 荷主請求id,
        請求年月: util.date.format(seikyuYM, "YYYY/MM/DD"),
        対象期間開始日: util.date.format(対象期間開始日, "YYYY/MM/DD"),
        対象期間終了日: util.date.format(対象期間終了日, "YYYY/MM/DD"),
        運送料課税額: summaryItems.運送料課税額,
        運送料非課税額: summaryItems.運送料非課税額,
        付帯料課税額: summaryItems.付帯料課税額,
        付帯料非課税額: summaryItems.付帯料非課税額,
        高速料: summaryItems.高速料,
        消費税: summaryItems.請求合計消費税,
        請求合計額: summaryItems.請求合計額,
        ヘッダー備考: "",
        フッター備考: フッター備考,
        請求処理状態区分コード: 請求処理状態区分コード,
        請求内訳情報リスト: seikyuUtiwakeList,
      }

      const service = new InvoiceHeaderService()

      let res: TApiResponse<TInvoiceHeaderListGetRes[]>
      res = await service.putMakeHeader(id, data)
      disPatch(setAlerts(res))
      if (res.data && res.data && res.data.length > 0) {
        isPrompt.current = false
        set請求番号(res.data[0].請求伝票番号)
        res.data[0].請求合計更新日時 &&
          set請求合計更新日時(res.data[0].請求合計更新日時)
        showInfoToast(`請求書表紙の登録が完了しました`)
        // ページにIDを埋め込む
        history.replace(`${location.pathname}/${res.data[0].請求合計ID}`)
      }
    } catch (error) {
      disPatch(setAlerts(error))
    } finally {
      setIsConfirmModalShow(false)
    }
  }

  // 荷主コード入力時の処理
  const inputNinusiCode = async (ninusiCode: string = "") => {
    // 未入力はスルー
    if (ninusiCode === "") {
      if (荷主コード === "") return
      ninusiCode = 荷主コード ? 荷主コード : ""
    }
    try {
      const 荷主res = await new NinusiService().getList({
        荷主コード: ninusiCode !== "" ? ninusiCode : undefined,
        完全一致フラグ: true,
      })
      if (荷主res.data == null || 荷主res.data.length <= 0) {
        set荷主名("")
        set表紙分割ItemSource([])
        set締日区分コード("")
        set高速料税込区分コード("")
        set消費税計算区分コード("")
        set明細ソート区分コード("")
        set請求書印刷区分コード("")
        return
      }

      const 荷主 = 荷主res.data[0]

      if (荷主 == null) {
        set荷主名("")
        set表紙分割ItemSource([])
        set締日区分コード("")
        set高速料税込区分コード("")
        set消費税計算区分コード("")
        set明細ソート区分コード("")
        set請求書印刷区分コード("")
      } else {
        set荷主名(荷主.荷主名)
        const ninusiSeikyuService = new NinusiSeikyuService()
        const 荷主請求res = await ninusiSeikyuService.getList({
          荷主Id: 荷主.荷主ID,
          請求書作成区分コード: id ? undefined : e請求書作成区分.手作成, //idがないときは手作成のみ
        })

        if (荷主請求res && 荷主請求res.data) {
          set表紙分割ItemSource([...荷主請求res.data])
          if (荷主請求res.data.length > 0) {
            set荷主請求id(荷主請求res.data[0].荷主請求ID)
          } else {
            set荷主請求id(undefined)
          }
        }
      }
    } catch (error) {
      dispatch(setAlerts(error))
    }
  }

  // 表紙分割コード選択時の処理
  const selectHyosiBunkatuCd = async (ninusiSeikyuID: number) => {
    clearError()

    if (!ninusiSeikyuID) {
      set締日区分コード("")
      set高速料税込区分コード("")
      set消費税計算区分コード("")
      set明細ソート区分コード("")
      set請求書印刷区分コード("")
      set対象期間("")
      set対象期間開始日("")
      set対象期間終了日("")
      return
    }

    const service = new NinusiSeikyuService()

    try {
      const res = await service.get(ninusiSeikyuID)
      if (res.data) {
        if (!id && res.data.請求書作成区分コード !== "3") {
          //「請求書作成区分：手作成」以外の場合（手作成分の請求書表紙）
          dispatch(
            setWarningAlerts([
              "「請求書作成区分：手作成」の表紙名を選択してください",
            ])
          )
          set請求書作成区分コード("")
          return
        }
        // 荷主請求マスタよりデータを取得
        set締日区分コード(res.data.締日区分コード)
        set高速料税込区分コード(res.data.高速料税込区分コード)
        set消費税計算区分コード(res.data.消費税計算区分コード)
        set明細ソート区分コード(res.data.明細ソート区分コード)
        set請求書印刷区分コード(res.data.請求書印刷区分コード)
        set請求書作成区分コード(res.data.請求書作成区分コード)

        // 請求対象期間の再計算
        getSeikyuKikan(請求年月 ? 請求年月 : "", res.data.締日区分コード)
      } else {
        set締日区分コード("")
        set高速料税込区分コード("")
        set消費税計算区分コード("")
        set明細ソート区分コード("")
        set請求書印刷区分コード("")
        set対象期間("")
        set対象期間開始日("")
        set対象期間終了日("")
      }
    } catch (error) {
      disPatch(setAlerts(error))
    }
  }

  // 請求対象期間の取得
  const getSeikyuKikan = (seikyuYM: string, simebiCode: string) => {
    if (seikyuYM === "" || simebiCode === "") {
      return
    }

    let seikyuDateFrom = new Date(seikyuYM)
    let seikyuDateTo = new Date(seikyuYM)

    switch (simebiCode) {
      case "20":
        // ２０日締め
        seikyuDateTo.setDate(20)
        seikyuDateFrom = new Date(seikyuDateTo)
        seikyuDateFrom.setMonth(seikyuDateFrom.getMonth() - 1)
        seikyuDateFrom.setDate(seikyuDateFrom.getDate() + 1)
        break

      case "25":
        // ２５日締め
        seikyuDateTo.setDate(25)
        seikyuDateFrom = new Date(seikyuDateTo)
        seikyuDateFrom.setMonth(seikyuDateFrom.getMonth() - 1)
        seikyuDateFrom.setDate(seikyuDateFrom.getDate() + 1)
        break

      default:
        // 月末締め
        seikyuDateFrom.setDate(1)
        seikyuDateTo = new Date(seikyuDateFrom)
        seikyuDateTo.setMonth(seikyuDateTo.getMonth() + 1)
        seikyuDateTo.setDate(seikyuDateTo.getDate() - 1)
        break
    }

    set対象期間(
      util.date.format(seikyuDateFrom, "YYYY/MM/DD") +
        "～" +
        util.date.format(seikyuDateTo, "YYYY/MM/DD")
    )
    set対象期間開始日(seikyuDateFrom.toString())
    set対象期間終了日(seikyuDateTo.toString())
  }

  /**
   * 請求書印刷処理
   */
  const printSeikyusyo = async () => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に

    let 請求書印刷区分 = 請求書印刷区分コード ?? undefined
    if (表紙編集モード !== "1") {
      // 表紙手作成の場合
      請求書印刷区分 = "1"
    }
    const printCondition: TInvoicePrintSeikyusyoReq = {
      抽出条件_請求伝票番号: 請求番号 ?? undefined,
      明細ソート区分: 明細ソート区分コード ?? undefined,
      請求書印刷区分: 請求書印刷区分,
      合計表題切替: 印刷設定_合計表題切替,
      表題切替: 印刷設定_表題切替,
      備考要否: 印刷設定_備考要否,
      頁不要: 印刷設定_頁不要,
      // 合計表題切替: 0, // 帳票の表題を「請求書」とする
      // 表題切替: 0, // 帳票の表題を「請求書」とする
      // 備考要否: 1, // フッター備考を印字する
    }

    try {
      const service = new MakeInvoiceService({ responseType: "blob" })
      let res

      if (
        請求書作成区分コード === e請求書作成区分.手作成 ||
        printCondition.請求書印刷区分 === "1"
      ) {
        // 手作成の場合は合体版は出しようがないため、強制的に表紙別とする
        // 表紙／明細別
        res = await service.printSeikyusyo(printCondition)
      } else {
        // 表紙明細合体版
        res = await service.printSeikyusyoGattaiban(printCondition)
      }

      let fileURL = URL.createObjectURL(res)
      window.open(fileURL)
      setTimeout(() => {
        URL.revokeObjectURL(fileURL)
      }, 500)
    } catch (error) {
      //dispatch(setAlerts(error))
      dispatch(setWarningAlerts(["エラー表示"]))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
    }
  }

  /**
   * 手作成削除処理
   */
  const delete手作成 = async () => {
    if (!id) return
    if (請求書作成区分コード !== e請求書作成区分.手作成) {
      dispatch(setWarningAlerts(["手作成の請求書以外は削除できません。"]))
      setIsDeleteModalShow(false)
      return
    }
    try {
      const res = await new InvoiceHeaderService().delete(id, {
        更新日時: 請求合計更新日時,
      })
      if (res && res.data) {
        setInfoAlerts([`請求番号:${請求番号}の請求書を削除しました。`])
        history.goBack()
      }
    } catch (error) {
      disPatch(setAlerts(error))
    } finally {
      setIsDeleteModalShow(false)
    }
  }

  /**
   * 手作成確認
   * idが存在する（編集モード）もしくは請求書作成区分コードが手作成以外かどうか確認する
   */
  const isNot手作成 = (請求書作成区分コード: string) =>
    id ||
    (請求書作成区分コード != null &&
      請求書作成区分コード !== "" &&
      請求書作成区分コード !== e請求書作成区分.手作成)
  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(100)
  const [gridData, setGridData] = useState<{
    data: wjCore.CollectionView<TInvoiceHeaderUtiwake>
  }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  // サマリ用グリッド
  const [summaryFlexGrid, setSummaryFlexGrid] = useState<wjGrid.FlexGrid>()
  const [summaryGridData, setSummaryGridData] = useState<{
    data: wjCore.CollectionView
  }>({
    data: createSummaryCollectionView([], 1),
  })
  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)
  const [summaryGridInitialized, setSummaryGridInitialized] =
    useState<boolean>(false)
  const [inputComboDataInitialized, setInputComboDataInitialized] =
    useState<boolean>(false)
  //#endregion

  //#region [state]
  const [請求年月, set請求年月] = useState<string | null | undefined>(前月)
  //TODO:テスト用に初期値入力
  const [荷主コード, set荷主コード] = useState<string | undefined>("")
  const [荷主名, set荷主名] = useState<string>()
  const [荷主請求id, set荷主請求id] = useState<number | null>()
  const [荷主請求id初期値, set荷主請求id初期値] = useState<number | null>()

  const [請求書作成区分コード, set請求書作成区分コード] = useState<string>("")
  const [対象期間, set対象期間] = useState<string>()
  const [対象期間開始日, set対象期間開始日] = useState<string>()
  const [対象期間終了日, set対象期間終了日] = useState<string>()
  const [請求番号, set請求番号] = useState<string>()
  const [フッター備考, setフッター備考] = useState<string>("")
  const [請求合計更新日時, set請求合計更新日時] = useState<string>("")
  const [請求処理状態区分コード, set請求処理状態区分コード] = useState<
    string | null
  >()

  //インボイス対応により削除
  //const [高速料項目表題, set高速料項目表題] = useState<string>("")

  const [表紙編集モード, set表紙編集モード] = useState<string>("")

  // 請求処理状態区分
  const [請求処理状態区分ComboBox, set請求処理状態区分ComboBox] =
    useState<TWijmoComboBox<T区分マスタ["区分コード"], T区分マスタ> | null>(
      null
    )
  const [請求処理状態区分IsLoadEnded, set請求処理状態区分IsLoadEnded] =
    useState<boolean>(false)

  const [区分ItemSource, set区分ItemSource] = useState<T区分マスタ[]>()

  //区分系
  const [課税区分DataMap, set課税区分DataMap] =
    useState<wjGrid.DataMap<T区分マスタ>>()
  const [税込区分DataMap, set税込区分DataMap] =
    useState<wjGrid.DataMap<T区分マスタ>>()
  const [金額区分DataMap, set金額区分DataMap] =
    useState<wjGrid.DataMap<T区分マスタ>>()

  // 表紙分割コード
  const [表紙分割ItemSource, set表紙分割ItemSource] =
    useState<TNinusiSeikyuListGetRes[]>()
  const [表紙分割ComboBox, set表紙分割ComboBox] = useState<TWijmoComboBox<
    T表紙分割["荷主請求ID"],
    T表紙分割
  > | null>(null)
  const [表紙分割IsLoadEnded, set表紙分割IsLoadEnded] = useState<boolean>(false)

  const [荷主請求内訳DataMap, set荷主請求内訳DataMap] =
    useState<wjGrid.DataMap<number, TSeikyuUtiwakeListInfo>>()

  const [締日区分コード, set締日区分コード] = useState<string>("")
  const [高速料税込区分コード, set高速料税込区分コード] = useState<string>("")
  const [消費税計算区分コード, set消費税計算区分コード] = useState<string>("")
  const [明細ソート区分コード, set明細ソート区分コード] = useState<string>("")
  const [請求書印刷区分コード, set請求書印刷区分コード] = useState<string>("")
  const [消費税率, set消費税率] = useState<number>(0)

  const [isDisabled登録, setIsDisabled登録] = useState(false)
  const [is合計再計算フラグ, setIs合計再計算フラグ] = useState(false)

  const [荷主請求id変更フラグ, set荷主請求id変更フラグ] = useState(false)

  const [isShowPrint, setIsShowPrint] = useState<boolean>(false)
  const [isExecPrint, setIsExecPrint] = useState<boolean>(false)

  // 請求書印刷設定
  const [印刷設定_合計表題切替, set印刷設定_合計表題切替] = useState<number>(0)
  const [印刷設定_表題切替, set印刷設定_表題切替] = useState<number>(0)
  const [印刷設定_備考要否, set印刷設定_備考要否] = useState<number>(1)
  const [印刷設定_頁不要, set印刷設定_頁不要] = useState<number>(0)

  // 更新 処理用
  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)

  // 削除 処理用
  const [isDeleteModalShow, setIsDeleteModalShow] = useState(false)

  //　エラー表示用フラグ
  const [isInvalid荷主コード, setIsInvalid荷主コード] = useState<boolean>(false)
  const [isInvalid荷主請求ID, setIsInvalid荷主請求ID] = useState<boolean>(false)
  const [isInvalidフッター備考, setIsInvalidフッター備考] =
    useState<boolean>(false)
  const [isInvalid請求処理状態区分コード, setIsInvalid請求処理状態区分コード] =
    useState<boolean>(false)

  //#endregion

  //#region [effect]
  //初期設定
  useEffect(() => {
    //画面全体ロック
    disPatch(画面ロック開始())

    Promise.all([new KubunService().getList()]).then(([区分マスタRes]) => {
      区分マスタRes && set区分ItemSource(区分マスタRes.data)
      set課税区分DataMap(
        new wjGrid.DataMap(
          区分マスタRes.data.filter(
            (d) => d.分類コード === 区分分類コード.受注配車_請求支払.課税区分
          ),
          "区分コード",
          "名称1"
        )
      )

      set税込区分DataMap(
        new wjGrid.DataMap(
          区分マスタRes.data.filter(
            (d) =>
              d.分類コード === 区分分類コード.受注配車_請求支払.税込区分 &&
              //インボイス対応 税込のみ表示
              d.区分コード === "1"
          ),
          "区分コード",
          "名称1"
        )
      )
      set金額区分DataMap(
        new wjGrid.DataMap(
          区分マスタRes.data.filter(
            (d) => d.分類コード === 区分分類コード.受注配車_請求支払.金額区分
          ),
          "区分コード",
          "名称1"
        )
      )

      setInputComboDataInitialized(true)
    })
  }, [])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (
      summaryGridInitialized &&
      gridInitialized &&
      inputComboDataInitialized &&
      表紙分割ComboBox
    ) {
      // id存在時はデータを取得し更新
      if (id) {
        getData().finally(() => {
          flexGrid?.refresh()
          disPatch(画面ロック解除())
          // ファイルロード後、戻るボタン押下時に警告が出るように変更
          isPrompt.current = true
        })
      } else {
        // 合計グリッド初期化
        const summaryData: TSummaryGrid[] = [
          {
            運送料課税額: 0,
            運送料非課税額: 0,
            付帯料課税額: 0,
            付帯料非課税額: 0,
            高速料: 0,
            請求合計消費税: 0,
            請求合計額: 0,
          },
        ]
        setSummaryGridData({
          data: createSummaryCollectionView(summaryData, 1),
        })
        disPatch(画面ロック解除())
        // ファイルロード後、戻るボタン押下時に警告が出るように変更
        isPrompt.current = true
      }
    }
  }, [
    summaryGridInitialized,
    gridInitialized,
    inputComboDataInitialized,
    表紙分割ComboBox,
  ])

  const cellEditEndedHandler = useGridEventHandler(
    flexGrid?.cellEditEnded,
    cellEditEnded
  )

  const cellEditEndingHandler = useGridEventHandler(
    flexGrid?.cellEditEnding,
    cellEditEnding
  )

  const beginningEditHandler = useGridEventHandler(
    flexGrid?.beginningEdit,
    beginningEdit
  )

  //ファンクション内部のstate更新のためイベント付け替え
  useEffect(() => {
    beginningEditHandler.refresh()
    cellEditEndingHandler.refresh()
    cellEditEndedHandler.refresh()
  }, [
    flexGrid,
    summaryFlexGrid,
    消費税計算区分コード,
    消費税率,
    荷主請求内訳DataMap,
  ])

  useEffect(() => {
    // 初期表示生成のため画面ロック
    dispatch(画面ロック開始())
  }, [])

  useEffect(() => {
    if (表紙分割IsLoadEnded) {
      set荷主請求id(荷主請求id初期値)
    }
  }, [表紙分割IsLoadEnded])

  useEffect(() => {
    if (表紙分割IsLoadEnded) {
      selectHyosiBunkatuCd(荷主請求id ? Number(荷主請求id) : 0)
    }
  }, [荷主請求id])

  const get荷主請求内訳DataMap = async (inner荷主請求ID: number) => {
    const 荷主請求内訳Res = await new NinusiSeikyuService().getListUchiwake({
      荷主請求Id: inner荷主請求ID,
    })
    if (荷主請求内訳Res && 荷主請求内訳Res.data) {
      set荷主請求内訳DataMap(create荷主請求DataMap(荷主請求内訳Res.data))
    }
  }

  /**
   * 荷主請求に対して存在しない請求内訳が入れられていた場合に削除を行う
   * @param flexGrid
   */
  const 荷主請求内訳初期化 = (innerFlexGrid: wjGrid.FlexGrid) => {
    if (!荷主請求内訳DataMap) return
    const 請求内訳data: Partial<TInvoiceHeaderListGetRes>[] =
      innerFlexGrid.collectionView.sourceCollection
    請求内訳data.forEach((d) => {
      if (
        d.荷主請求内訳ID != null &&
        !荷主請求内訳DataMap.getDataItem(d.荷主請求内訳ID)
      ) {
        d.荷主請求内訳ID = undefined
        d.請求内訳コード = undefined
        d.請求内訳名 = undefined
      }
      innerFlexGrid.refresh()
    })
  }

  //手作成モード時のみ動作
  useEffect(() => {
    if (isNot手作成(請求書作成区分コード)) return
    if (!flexGrid) return
    if (荷主請求id != null && 荷主請求id !== 0) {
      get荷主請求内訳DataMap(荷主請求id)
    }
  }, [荷主請求id, flexGrid])

  //手作成モード時のみ動作
  useEffect(() => {
    if (isNot手作成(請求書作成区分コード)) return
    if (!flexGrid) return
    if (!荷主請求id変更フラグ) return
    if (荷主請求id != null && 荷主請求id !== 0) {
      get荷主請求内訳DataMap(荷主請求id)
      荷主請求内訳初期化(flexGrid)
      set荷主請求id変更フラグ(false)
    }
  }, [荷主請求id変更フラグ])

  useEffect(() => {
    // 請求対象期間の再計算
    getSeikyuKikan(
      請求年月 ? 請求年月 : "",
      締日区分コード ? 締日区分コード : ""
    )

    // 消費税率の取得
    getSyohizeiRitu(請求年月)
  }, [請求年月])

  //インボイス対応により不要となったため削除
  // useEffect(() => {
  //   // 高速料見出しの設定
  //   if (高速料項目表題 == null || summaryFlexGrid == null) return

  //   let columnHeaders = summaryFlexGrid.columnHeaders

  //   columnHeaders.columns.forEach((c, index) => {
  //     if (c.binding != null) {
  //       let setHeaderText = ""
  //       if (["運送料課税額", "運送料非課税額"].includes(c.binding)) {
  //         setHeaderText = "運送料・その他"
  //       } else if (["付帯料課税額", "付帯料非課税額"].includes(c.binding)) {
  //         setHeaderText = "運送付帯料"
  //         // } else if (["高速料"].includes(c.binding)) {
  //         //   setHeaderText = 高速料項目表題
  //         //   columnHeaders.setCellData(1, index, setHeaderText)
  //       } else {
  //         setHeaderText = c.header ?? ""
  //       }
  //       c.allowMerging = true
  //       columnHeaders.setCellData(0, index, setHeaderText)
  //     }
  //   })
  //   summaryFlexGrid.refresh()
  // }, [高速料項目表題])

  useEffect(() => {
    if (is合計再計算フラグ) {
      合計額再計算()
      setIs合計再計算フラグ(false)
      const sourceCollection: TInvoiceHeaderListGetReq[] =
        flexGrid?.collectionView.sourceCollection
      setIsDisabled登録(
        sourceCollection && sourceCollection?.length > 0 ? false : true
      )
    }
  }, [is合計再計算フラグ])

  useEffect(() => {
    if (isExecPrint) {
      setIsExecPrint(false)
      disPatch(画面ロック開始())
      submit().then(() => {
        printSeikyusyo().finally(() => {
          disPatch(画面ロック解除())
        })
      })
    }
  }, [isExecPrint])

  //#endregion

  return (
    <>
      <Container fluid>
        {/* 画面タイトル */}
        <Row className="page-title-row">
          <Col className="page-title-col">
            <span className="page-title">請求書表紙</span>
          </Col>
        </Row>
        {/* アラート表示 */}
        <Row>
          <Col>
            <AlertComponent />
          </Col>
        </Row>
        <Row>
          <Col>
            {/* 検索条件カード */}
            <Card>
              <Card.Body>
                <Form>
                  <Container fluid className="contents-search-main">
                    <Row>
                      <Col>
                        <Table className="form-table">
                          <tbody>
                            <tr>
                              <th className="min-w-8rem">荷主</th>
                              <td>
                                <div className="input-group">
                                  <TextInput
                                    id="荷主コード"
                                    name="荷主コード"
                                    value={荷主コード}
                                    setValue={set荷主コード}
                                    onBlur={() => {
                                      // idありの場合変更は起きないためスルーする
                                      if (id) return
                                      inputNinusiCode()
                                    }}
                                    isReadOnly={id ? true : false}
                                    style={{ width: "5rem" }}
                                    className={
                                      isInvalid荷主コード ? "is-error" : ""
                                    }
                                  />
                                  <TextInput
                                    id="荷主名"
                                    name="荷主名"
                                    value={荷主名}
                                    setValue={set荷主名}
                                    maxLength={100}
                                    isReadOnly={true}
                                    style={{ width: "25rem" }}
                                  />
                                </div>
                              </td>
                              <th className="min-w-8rem">請求年月</th>
                              <td>
                                <div className="input-group">
                                  <MonthInput
                                    id="請求年月"
                                    value={請求年月}
                                    setValue={set請求年月}
                                    isReadOnly={id ? true : false}
                                  />
                                </div>
                              </td>
                              <th className="min-w-8rem">請求番号</th>
                              <td>
                                <div className="input-group">
                                  <TextInput
                                    id="請求番号"
                                    name="請求番号"
                                    value={請求番号}
                                    setValue={set請求番号}
                                    maxLength={100}
                                    isReadOnly={true}
                                  />
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <th className="min-w-8rem">表紙名</th>
                              <td>
                                <div className="input-group">
                                  <div className="w-20rem">
                                    <ComboBox.HyosiBunkatu
                                      isReadOnly={
                                        表紙分割ItemSource == null ||
                                        表紙分割ItemSource.length <= 0 ||
                                        id
                                          ? true
                                          : false
                                      }
                                      isAllSelect={false}
                                      itemsSource={表紙分割ItemSource}
                                      isLoadEnded={表紙分割IsLoadEnded}
                                      setIsLoadEnded={set表紙分割IsLoadEnded}
                                      // listFilter={(item) =>
                                      //   item.請求書作成区分コード ===
                                      //   e請求書作成区分.手作成
                                      // }
                                      lostFocus={() => {
                                        // 登録後は変わることはない
                                        if (id) return
                                        set荷主請求id変更フラグ(true)
                                      }}
                                      selectedValue={荷主請求id}
                                      setSelectedValue={set荷主請求id}
                                      ComboBox={表紙分割ComboBox}
                                      setComboBox={set表紙分割ComboBox}
                                      className={
                                        isInvalid荷主請求ID ? "is-error" : ""
                                      }></ComboBox.HyosiBunkatu>
                                  </div>
                                </div>
                              </td>
                              <th className="min-w-8rem">対象期間</th>
                              <td>
                                <div className="input-group">
                                  <TextInput
                                    id="対象期間"
                                    name="対象期間"
                                    value={対象期間}
                                    setValue={set対象期間}
                                    maxLength={100}
                                    isReadOnly={true}
                                  />
                                </div>
                              </td>
                              <th className="min-w-8rem">請求処理状態</th>
                              <td>
                                <div className="input-group">
                                  <div className="w-10rem">
                                    <ComboBox.Kubun
                                      分類コード={
                                        区分分類コード.受注配車_請求支払
                                          .請求支払処理状態区分
                                      }
                                      isLoadEnded={請求処理状態区分IsLoadEnded}
                                      setIsLoadEnded={
                                        set請求処理状態区分IsLoadEnded
                                      }
                                      itemsSource={区分ItemSource}
                                      selectedValue={請求処理状態区分コード}
                                      setSelectedValue={
                                        set請求処理状態区分コード
                                      }
                                      ComboBox={請求処理状態区分ComboBox}
                                      setComboBox={set請求処理状態区分ComboBox}
                                      className={
                                        isInvalid請求処理状態区分コード
                                          ? "is-error"
                                          : ""
                                      }></ComboBox.Kubun>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col>
            {/* 合計カード */}
            <Card>
              {/* <Spinner searching={isSearching}></Spinner> */}
              <Card.Body>
                <FlexGridOuter
                  flexGrid={summaryFlexGrid}
                  gridConstantProperties={
                    CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS_TOTAL
                  }
                  setFlexGrid={setSummaryFlexGrid}
                  gridData={summaryGridData}
                  setGridData={setSummaryGridData}
                  pageNumber={pageNumber}
                  gridId={`${gridId}_1`}
                  isRestoreSearching={isRestoreSearching}
                  setIsRestoreSearching={setIsRestoreSearching}
                  gridInitialized={summaryGridInitialized}
                  setGridInitialized={setSummaryGridInitialized}
                  pageSize={pageSize}
                  setPageSize={setPageSize}
                  gridInitializedHandler={summaryGridInitializedHandler}
                  isShowGridFooter={false}
                  isShowGridRowPickupButton={false}
                  hasFilter={false}>
                  <wjrGrid.FlexGridColumn
                    binding="運送料課税額"
                    cssClass="number-col"
                    cssClassAll={"read-only-cell"}
                    width={120}
                    header="課税額"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="運送料非課税額"
                    cssClass="number-col"
                    width={120}
                    cssClassAll={"read-only-cell"}
                    header="非課税額"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="付帯料課税額"
                    cssClass="number-col"
                    width={120}
                    cssClassAll={"read-only-cell"}
                    header="課税額"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="付帯料非課税額"
                    cssClass="number-col"
                    width={120}
                    cssClassAll={"read-only-cell"}
                    header="非課税額"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="高速料"
                    cssClass="number-col"
                    width={120}
                    cssClassAll={"read-only-cell"}
                    header="課税額"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="請求合計消費税"
                    cssClass="number-col"
                    width={150}
                    cssClassAll={"read-only-cell "}
                    header="消費税"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="請求合計額"
                    cssClass="number-col"
                    width={120}
                    header="請求合計額"
                    cssClassAll={"read-only-cell"}></wjrGrid.FlexGridColumn>
                </FlexGridOuter>
              </Card.Body>
            </Card>
            {/* 内訳カード */}
            <Card>
              <Spinner searching={isSearching}></Spinner>
              <Card.Body>
                <FlexGridOuter
                  flexGrid={flexGrid}
                  setFlexGrid={setFlexGrid}
                  hasFilter={false}
                  gridProperties={{
                    allowAddNew: 表紙編集モード === "1" ? false : true,
                    showMarquee:
                      CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS_EDIT.showMarquee,
                    keyActionTab:
                      CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS_EDIT.keyActionTab,
                    alternatingRowStep:
                      CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS_EDIT
                        .alternatingRowStep,
                    selectionMode:
                      CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS_EDIT
                        .selectionMode,
                    headersVisibility:
                      CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS_EDIT
                        .headersVisibility,
                    width: CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS_EDIT.width,
                  }}
                  gridData={gridData}
                  setGridData={setGridData}
                  pageNumber={pageNumber}
                  gridId={`${gridId}_2`}
                  isRestoreSearching={isRestoreSearching}
                  setIsRestoreSearching={setIsRestoreSearching}
                  gridInitialized={gridInitialized}
                  setGridInitialized={setGridInitialized}
                  pageSize={pageSize}
                  setPageSize={setPageSize}
                  isShowGridFooter={false}
                  gridInitializedHandler={gridInitializedHandler}
                  headerComponent={
                    <>
                      <Button
                        className="btn-done"
                        onClick={() => {
                          beforeSubmit("印刷")
                        }}
                        disabled={id ? false : true}>
                        <FontAwesomeIcon icon={faFileAlt} />
                        請求書印刷
                      </Button>
                    </>
                  }>
                  <wjrGrid.FlexGridColumn
                    binding="金額区分コード"
                    width={120}
                    isReadOnly={表紙編集モード === "1" ? true : false}
                    cssClassAll={表紙編集モード === "1" ? "read-only-cell" : ""}
                    dataMap={金額区分DataMap}
                    visible={表紙編集モード === "1" ? false : true}
                    header="金額区分"></wjrGrid.FlexGridColumn>

                  {/* 手作成の請求内訳 */}
                  <wjrGrid.FlexGridColumn
                    binding="荷主請求内訳ID"
                    width={285}
                    dataMap={荷主請求内訳DataMap}
                    visible={表紙編集モード === "1" ? false : true}
                    isRequired={false}
                    header="請求内訳">
                    {/* <wjrGrid.FlexGridCellTemplate
                      cellType="Cell"
                      template={(
                        context: TWijmoCellTemplateContext<TInvoiceHeaderUtiwake>
                      ) => {
                        const boundItem: TInvoiceHeaderUtiwake = context.item
                        return <>{boundItem.請求内訳名}</>
                      }}
                    /> */}
                  </wjrGrid.FlexGridColumn>

                  {/* 手作成以外の請求内訳 */}
                  <wjrGrid.FlexGridColumn
                    binding="請求内訳名"
                    isReadOnly={表紙編集モード === "1" ? true : false}
                    cssClassAll={表紙編集モード === "1" ? "read-only-cell" : ""}
                    visible={表紙編集モード === "1" ? true : false}
                    width={285}
                    header="請求内訳"></wjrGrid.FlexGridColumn>

                  <wjrGrid.FlexGridColumn
                    binding="課税区分コード"
                    width={80}
                    isReadOnly={表紙編集モード === "1" ? true : false}
                    cssClassAll={表紙編集モード === "1" ? "read-only-cell" : ""}
                    dataMap={課税区分DataMap}
                    visible={表紙編集モード === "1" ? false : true}
                    header="課税区分"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="課税区分名称"
                    width={80}
                    isReadOnly={表紙編集モード === "1" ? true : false}
                    cssClassAll={表紙編集モード === "1" ? "read-only-cell" : ""}
                    visible={表紙編集モード === "1" ? true : false}
                    header="税区分"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="税込区分コード"
                    width={80}
                    isReadOnly={表紙編集モード === "1" ? true : false}
                    cssClassAll={表紙編集モード === "1" ? "read-only-cell" : ""}
                    dataMap={税込区分DataMap}
                    //visible={表紙編集モード === "1" ? false : true}
                    visible={false}
                    header="税込区分"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="数量"
                    cssClass="number-col"
                    dataType={wjCore.DataType.Number}
                    width={80}
                    isReadOnly={表紙編集モード === "1" ? true : false}
                    cssClassAll={表紙編集モード === "1" ? "read-only-cell" : ""}
                    format={"N3"}
                    header="数量"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="金額"
                    cssClass="number-col"
                    dataType={wjCore.DataType.Number}
                    width={120}
                    isReadOnly={表紙編集モード === "1" ? true : false}
                    cssClassAll={表紙編集モード === "1" ? "read-only-cell" : ""}
                    header="金額"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="請求内訳消費税"
                    visible={false}
                    cssClass="number-col"
                    dataType={wjCore.DataType.Number}
                    width={120}
                    isReadOnly={false}
                    cssClassAll={"number-col"}
                    header="消費税"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    visible={false}
                    binding="修正前請求内訳消費税"
                    cssClass="number-col"
                    width={120}
                    isReadOnly={true}
                    cssClassAll={"read-only-cell"}
                    header="修正前消費税"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    visible={false}
                    binding="合計額"
                    cssClass="number-col"
                    dataType={wjCore.DataType.Number}
                    width={120}
                    isReadOnly={true}
                    cssClassAll={"read-only-cell"}
                    header="合計額"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    visible={false}
                    binding="修正前合計額"
                    cssClass="number-col"
                    width={120}
                    isReadOnly={true}
                    cssClassAll={"read-only-cell"}
                    header="修正前合計額"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="備考"
                    width={300}
                    header="備考"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="受注配車工程ID"
                    width={64}
                    isReadOnly={true}
                    visible={
                      !id || 請求書作成区分コード === e請求書作成区分.手作成
                    }
                    header="削除">
                    <wjrGrid.FlexGridCellTemplate
                      cellType="Cell"
                      template={(
                        context: TWijmoCellTemplateContext<TInvoiceHeaderUtiwake>
                      ) => {
                        const boundItem: TInvoiceHeaderUtiwake = context.item
                        return (
                          <Button
                            className="btn btn-small btn-primary move-edit-page"
                            disabled={
                              !!id &&
                              請求書作成区分コード !== e請求書作成区分.手作成
                            }
                            variant={"caution"}
                            onClick={(e) => {
                              e.preventDefault()
                              e.stopPropagation()
                              if (boundItem) {
                                // 行削除
                                gridData.data.remove(boundItem)
                              }
                            }}>
                            削除
                          </Button>
                        )
                      }}
                    />
                  </wjrGrid.FlexGridColumn>
                </FlexGridOuter>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col>
            {/* ヘッダーフッター入力用・登録ボタン用カード */}
            <Card>
              <Card.Body>
                <Form>
                  <Container fluid className="contents-search-main">
                    <Row>
                      <Col>
                        <Table className="form-table">
                          <tbody>
                            <tr>
                              <th className="min-w-8rem">備考</th>
                              <td>
                                <TextAreaInput
                                  style={{
                                    width: "60rem",
                                    overflow: "hidden",
                                    lineHeight: "1.5rem",
                                    maxHeight: "3.2rem",
                                    minHeight: "3.2rem",
                                  }}
                                  id="フッター備考"
                                  name="フッター備考"
                                  value={フッター備考}
                                  setValue={setフッター備考}
                                  placeholder="備考"
                                  rows={2}
                                  maxLength={101}
                                  className={
                                    isInvalidフッター備考 ? "is-error" : ""
                                  }
                                />
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col xl={{ span: "auto", offset: 0 }}>
            {/* 請求内訳が作られていない手作成の場合 そもそも登録できない*/}
            <Button
              type="submit"
              variant="waiting"
              className="me-4"
              disabled={isDisabled登録}
              onClick={(e) => {
                e.stopPropagation()
                e.preventDefault()
                beforeSubmit("登録更新")
              }}>
              {id === 0 || cp === 1 ? `登録` : `更新`}
            </Button>
            <Button
              size="lg"
              hidden={!id || 請求書作成区分コード !== e請求書作成区分.手作成}
              variant="caution"
              className="me-4"
              disabled={
                請求処理状態区分コード === e請求支払処理状態区分.送付済 ||
                請求処理状態区分コード === e請求支払処理状態区分.確定
              }
              onClick={(e) => {
                e.stopPropagation()
                e.preventDefault()
                setIsDeleteModalShow(true)
              }}>
              削除
            </Button>
            <Button
              type="button"
              variant="secondary"
              onClick={() => history.goBack()}>
              一覧に戻る
            </Button>
          </Col>
        </Row>
      </Container>
      <MakeInvoicePrintModal
        isHeaderPage={true}
        isShow={isShowPrint}
        setIsShow={setIsShowPrint}
        isExecPrint={isExecPrint}
        setIsExecPrint={setIsExecPrint}
        size={"sm"}
        title={"請求書印刷処理実行"}
        合計表題切替={印刷設定_合計表題切替}
        set合計表題切替={set印刷設定_合計表題切替}
        表題切替={印刷設定_表題切替}
        set表題切替={set印刷設定_表題切替}
        備考要否={印刷設定_備考要否}
        set備考要否={set印刷設定_備考要否}
        頁不要={印刷設定_頁不要}
        set頁不要={set印刷設定_頁不要}></MakeInvoicePrintModal>
      <ConfirmModal
        isShow={isDeleteModalShow}
        hideHandler={setIsDeleteModalShow}
        submitHandler={delete手作成}>
        請求書を削除しますか？
      </ConfirmModal>
      <ConfirmModal
        isShow={isConfirmModalShow}
        hideHandler={setIsConfirmModalShow}
        submitHandler={submit}>
        入力された内容で{id === 0 || cp === 1 ? `登録` : `更新`}しますか？
      </ConfirmModal>
    </>
  )
}

export default InvoiceHeader
